export enum TwoFactorVerificationTypes {
  Authenticator = 'authenticator',
  Fido = 'fido',
}

export enum ActivationEmailEnum {
  OK = 'ok',
  ACTIVATION_REQUIRED = 'activation_required',
}
